import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls to top on every route change
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Reset scroll instantly to the absolute top-left
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  }, [pathname]);

  return null;
}
